var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackAccessActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-82-Copy-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFBD09",
    cx: 10,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.8,
    fill: "#000A19",
    cx: 7,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-15",
    fillOpacity: 0.8,
    fill: "#000A19",
    cx: 13,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "LUI-icon-pd-add-solid-16",
    transform: "translate(14.000000, 0.000000)",
    fill: "#0BC7C2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    points: "8 5 5 5 5 8 3 8 3 5 0 5 0 3 3 3 3 0 5 0 5 3 8 3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7,15 C7.5,15.6666667 8.5,16 10,16 C11.5,16 12.5,15.6666667 13,15",
    id: "Path-8",
    strokeOpacity: 0.8,
    stroke: "#000A19",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackAccessActive);
export default __webpack_public_path__ + "static/media/feedback-access-active.318705a7ce0211a19e3f6998ce7ad775.svg";
export { ForwardRef as ReactComponent };